import { useState, useEffect, useRef } from "react";
import AdTables from "../../components/AdFlow/AdTables";
import AdPlaceBidSection from "../../components/AdFlow/AdPlaceBidSection";
import VBLeaflet from '@virkesborsen/vb-js-commons/lib/components/new/vbLeaflet';
import Cookies from 'js-cookie';
import VBLoadingScreen from '@virkesborsen/vb-js-commons/lib/components/vbLoadingScreen';
import { getProp, searchProps } from "../../api/services/property";
import { sendAdForReview, bookmarkAd } from "../../api/services/ad";
import { ErrorModal } from "../../modals";

import Navigation from '../../components/static/Navigation';
import Footer from '../../components/static/Footer';
import { LayerSelector, ZoomAndLayerButtons } from "../../components/mapComponents/MapComponents";

const AuctionDetailsPage = () => {
    const [ad, setAd] = useState(Window.react_data.ad);
    const [bookmarked, setBookmarked] = useState(Window.react_data.ad ? Window.react_data.ad.bookmarked : false);
    const [loading, setLoading] = useState(false);
    const [directionCoords, setDirectionCoords] = useState(
        Window.react_data.ad.longitude && Window.react_data.ad.latitude ? `${Window.react_data.ad.latitude},${Window.react_data.ad.longitude}` : "0,0"
    );
    const [errorModal, setErrorModal] = useState(false);
    const [errorModalText, setErrorModalText] = useState('');
    const [mapTools, setMapTools] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [geoJsonLayers, setGeoJsonLayers] = useState(null);

    const mapRef = useRef(null);
    const geojsonLayersRef = useRef(null);
    const attachmentRef = useRef();

      // Map related
    const updateMapWithSelectedProperty = async (registerenhet) => {
        const borders = L.featureGroup([]);
        const response = await getProp(registerenhet);
        if (response.ok) {
            const propertyLayer = L.geoJson(response.data.geojson, { color: "#ffffff", fillColor: "transparent" });
            propertyLayer.bringToBack();
            borders.addLayer(propertyLayer);
            mapRef.current.setLayers(borders);
            borders.addTo(mapRef.current.state.map);
            if (ad.geom && Object.keys(ad.geom).length !== 0 && geojsonLayersRef.current) {
                mapRef.current.state.map.fitBounds(geojsonLayersRef.current.getBounds());
            } else {
                mapRef.current.state.map.fitBounds(propertyLayer.getBounds());
            }
            setLoading(false);
        } else {
            handleServerError(response.status, 'Försök igen senare eller kontakta oss.', 'Den här funktionen är inte tillgänglig.');
        }
    };

    const searchProp = async (val) => {
        const result = await searchProps(val);
        if (result.ok) updateMapWithSelectedProperty(result.data[0].registerenhet);
        else handleServerError(result.status, 'Försök igen senare eller kontakta oss.', 'Den här funktionen är inte tillgänglig.');
    };

    useEffect(() => {
        const drawnItems = L.featureGroup([]);
        setTimeout(() => {
            if (mapRef.current && Window.react_data.trustedBuyer) {
                const { ad } = Window.react_data;
                if (ad?.description_of_property) {
                    ad.description_of_property.split('&').forEach(desc => searchProp(desc.trim()));
                }
                if (ad?.geom && Object.keys(ad.geom).length !== 0) {
                    let geoJson = L.geoJson(ad.geom, { color: "#DFFF5D" });
                    drawnItems.addLayer(geoJson);
                    mapRef.current.setLayers(drawnItems);
                    drawnItems.addTo(mapRef.current.state.map);
                    mapRef.current.state.map.fitBounds(geoJson.getBounds());
                    setGeoJsonLayers(geoJson);
                }
            }
        }, 500);
    }, []);

    useEffect(() => {
        if (refresh) setRefresh(false);
    }, [refresh]);

    useEffect(()=>{
        geojsonLayersRef.current = geoJsonLayers
    },[geoJsonLayers])

    //API
    const handleServerError = (status, text500, text400) => {
        if (status >= 500) {
            setErrorModalText(text500);
            setErrorModal(true);
        } else if (status >= 400) {
            setErrorModalText(text400);
            setErrorModal(true);
        }
    };

    const sendForReview = async () => {
        setLoading(true);
        Cookies.remove('ad_id');
        const response = await sendAdForReview(window.location);
        if (response.ok) {
            window.location.href = window.location.href.replace("/review/", "")
        } else {
            handleServerError(resp.status, 'Försök igen senare eller kontakta oss.', 'Den här funktionen är inte tillgänglig.');
        }
    }

  

    const handleBookmarkClick = async (event) => {
        event.stopPropagation();
        const response = await bookmarkAd(window.location);
        if (response.ok) {
            setBookmarked(response.data.bookmarked);
            setLoading(false)
        }
        else {
            console.error("Error setting bookmark", response.status)
        }
    }

    // helpers
    const redirectAfterServerError = () => {
        window.location.href = '/'
    }
    const cleanNumbers = (num) => {
        return Math.round(Number(num)).toString().replace(".0", "").replace(".", ",")
    }

    const reviewActions = () => {
        return(<div className='d-flex justify-content-end align-items-center'>
            <a className='n-btn btn-ghost btn-outline btn-sm me-3' href="/auctions/create/">Redigera</a>
            {/* Submit for review */}
            <button className="n-btn btn-core btn-sm" onClick={() => sendForReview()}>Skicka till granskning<span><img className={`ms-2 neutral-charcoal-filter`} style={{ width: "16px", height: "16px" }} src={Window.static_path + "img/icons/arrow-black.svg"} /></span></button>
        </div>)
    }

    return <div className="container-fluid d-flex flex-column vh-100 justify-content-between p-0">
        <VBLoadingScreen show_loading={loading} disable_reload_timeout={false} loading_text={null} />

        <Navigation />

        <section className='bg-white n-fs-6 pt-0 pt-md-3'>
            {ad.should_display_popup ? <>
                {Window.user_data.isBanned ? <>
                    <div className="container">
                        <div className="row flex-md-row align-items-start justify-content-center">
                            <div className='col-md-6 col-12'>
                                <img src={`${Window.static_path}img/icons/Warning.svg`} className='tertiary-red-filter me-1' height='16px' width='16px' alt='Warning Icon' />
                                <p className='text-center mb-0 tertiary-red subtitle fw-bold mb-3'>
                                    Du har inte tillgång till att öppna och se annonser, kontakta Treebula för mer information på
                                    <a className='text-decoration-underline fw-bold' style={{ cursor: 'pointer' }} href="tel:00468339944"> 08339944</a> eller maila till <a className='text-decoration-underline fw-bold' style={{ cursor: 'pointer' }} href="mailto:info@virkesborsen.se">info@virkesborsen.se.</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </> : <>
                    <div className="container">
                        <div className="row flex-md-row">

                            {/*Ads */}
                            <div className='p-2 mb-3 order-1 order-md-1'>

                                <div className='d-flex align-items-center justify-content-center mb-4'>
                                    <p className="ms-2 n-fs-2 fw-medium text-center"><span><img onClick={(e) => { handleBookmarkClick(e) }}
                                        src={`${Window.static_path}img/icons/${bookmarked ? 'bookmark_star_orange.svg' : 'bookmark_star.svg'}`}
                                        height='24px' width='24px' alt='BookMark' /></span> {ad && ad.label || ''}
                                        {ad && ad.fullserviceadorder && !actionIsLive && ad.fullserviceadorder.state_display_name}</p>
                                </div>

                                <div className='d-flex flex-wrap column align-items-center justify-content-center'>
                                    <p className='me-2 mb-0 n-fs-6 fw-medium'>{cleanNumbers(ad.total_volume)} m³fub </p>
                                    <span className='me-2'>|</span>
                                    <p className='me-2 mb-0 n-fs-6'>{ad.arrangement_types} </p>
                                    <span className='me-2'>|</span>
                                    <p className='me-2 mb-0 n-fs-6'>{ad.type}</p>
                                    {ad.auction_is_over && (
                                        <p className='mb-0 n-fs-6'><span className='me-2'>|</span>Slutdatum: {ad.end_time}</p>
                                    )}
                                    {ad.auction_in_future && (
                                        <p className='mb-0 n-fs-6'><span className='me-2'>|</span>Startdatum: {ad.start_time}</p>
                                    )}
                                    {ad.auction_is_live && (
                                        <p className='mb-0 n-fs-6'><span className='me-2'>|</span>Slutdatum: {ad.end_time}</p>
                                    )}
                                </div>
                            </div>

                            {/*Left Section*/}
                            <div className="bg-white primary-dark col-12 col-lg-8 col-md-6 mb-4 order-3 order-md-2">
                                {/*Leaflet Map*/}
                                <div className='d-flex justify-content-center position-relative' style={{ height: "500px", borderRadius: "16px" }}>
                                    {Window.react_data.trustedBuyer ? null : <div className='d-flex align-items-center justify-content-center px-4 position-absolute' style={{ backgroundColor: 'rgba(0,0,0,0.7)', width: '100%', height: '500px', zIndex: 1010, borderRadius: "15px" }}>
                                        <a href="/kontakta-oss/" className='n-btn btn-core'>Kontakta oss för att se all information</a>
                                    </div>}
                                    <VBLeaflet ref={mapRef} id='map_auctions' baseMap='Mapbox Satelite' />
                                    <ZoomAndLayerButtons mapRef={mapRef} mapTools={mapTools} setMapTools={(val) => { setMapTools(val) }} />
                                    {mapTools && <LayerSelector mapRef = {mapRef} mapTools={mapTools} setMapTools = {(val)=>{setMapTools(val)}} setRefresh={(val)=>setRefresh(val)}/>}
                                </div>

                                {Window.react_data.trustedBuyer ? <div className="p-4 d-flex justify-content-center alignt-items-center" ><button className="n-btn btn-forest-green" onClick={() => { window.open(`https://www.google.com/maps/dir//${directionCoords}/`, "_blank") }}>Vägbeskrivning</button></div> : null}

                                {/*All Tables*/}
                                <AdTables attachmentRef={attachmentRef} />
                            </div>

                            {/*Right Section*/}
                            <div className="bg-white primary-dark col-12 col-lg-4 col-md-6 order-2 order-md-3">
                                {/* only for Adreview */}
                                {/* only tablet & DT view */}
                                {window.location.href.includes("/review") ?
                                    <div className='d-none mb-4 shadow p-3 d-md-flex flex-column justify-content-center bg-neutral-cloud' style={{ position: 'sticky', top: '24px', borderRadius: '12px', marginBottom: '24px' }}>
                                        {/* Edit Ad */}
                                        <div className='container'>
                                            <p className='ms-2 n-fs-5 fw-medium mb-0'>Välj en för att fortsätta med din annons:</p>
                                            {reviewActions()}
                                        </div>
                                    </div> :
                                    <AdPlaceBidSection toggle_loading={() => { setLoading(!loading); }} scrollCallback={()=>{attachmentRef.current.scrollIntoView({ behavior: 'smooth' })}} />}
                            </div>
                        </div>
                    </div>                 
                    {/* only for Adreview */}
                    {/* only for Mobile view*/}
                    {window.location.href.includes("/review") ?
                        <div className="d-md-none position-sticky bg-neutral-stone-100 w-100 py-4 start-0 bottom-0" style={{ zIndex: 1000 }}>
                            {/* Edit Ad */}
                            <div className='container'>
                                {reviewActions()}
                            </div>
                        </div> : null}
                    <ErrorModal show={errorModal} title={"Oops! Något gick fel."} message={errorModalText} onToggle={() => {setErrorModal(false); redirectAfterServerError()}} />
                </>}
            </> : <>
                <div className="container neutral-charcoal">
                    <div className="row flex-md-row justify-content-center">
                        <div className='col-md-6 col-12'>
                            {/* Conditions for opening an ad */}
                            <h1 className="mb-2 n-fs-4 text-center mt-4">Villkor för öppning av annons</h1>
                            {/* Click "I agree" to see the full information and confirm that you have read our terms of use and thus may not submit tenders directly to the forest owner on this advertisement. Read our terms of use */}
                            <p className='text-center n-fs-6'>Klicka "Jag godkänner" för att se den fullständiga informationen och bekräfta att du har tagit del av våra användarvillkor och därmed inte får lämna anbud direkt till skogsägaren på denna annons. Läs våra användarvillkor
                                <a className='supp-spruce text-decoration-underline fw-bold' style={{ cursor: 'pointer' }} href="/terms" target="_blank" rel="noopener noreferrer"> här.</a>
                            </p>
                            <div className="row flex-md-row justify-content-center">
                                <form className='col-md-8 col-12' method="post">
                                    <input type="hidden" name="csrfmiddlewaretoken" value={Cookies.get('csrftoken')} />
                                    <input
                                        type="submit"
                                        data-track="true"
                                        data-eventName="Opened Ad"
                                        data-eventData={`{"ad_end_date":"_date${ad.end_time}"}`}
                                        className='n-btn btn-core text-nowrap w-100 mb-3 btn-sm d-block' style={{ minWidth: '100px' }}
                                        value="Jag godkänner"
                                        name="accept_terms"
                                    />
                                    {/* Cancel */}
                                    <a className='n-btn btn-outline btn-charcoal btn-sm text-nowrap w-100 mb-3 d-block' style={{ minWidth: '100px' }} href="/">
                                        Avbryt
                                    </a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </>}
        </section>

        <Footer />
    </div>
}

export default AuctionDetailsPage;